import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { Check } from "lucide-react";
import { formatMoney } from "@/lib/currency";

export default function CheckoutSuccess() {
  const { sessionId } = useParams();
  const [session, setSession] = useState(null);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    api.get(`/checkout/session/${sessionId}`).then((r) => setSession(r.data)).catch(() => {});
  }, [sessionId]);

  useEffect(() => {
    if (session && session.status !== "paid" && !completed) {
      // auto-complete the mock session
      api.post(`/checkout/session/${sessionId}/complete`).then((r) => { setSession(r.data); setCompleted(true); }).catch(() => {});
    }
  }, [session, sessionId, completed]);

  return (
    <div className="bg-ivory min-h-screen flex flex-col" data-testid="checkout-success">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-8 py-24">
        <div className="max-w-xl text-center">
          <div className="w-16 h-16 mx-auto rounded-full border-2 border-brass flex items-center justify-center mb-8">
            <Check className="w-7 h-7 text-brass" />
          </div>
          <span className="editorial-label">order · confirmed</span>
          <h1 className="font-serif text-5xl lowercase text-charcoal mt-3 mb-4">thank you.</h1>
          <p className="text-espresso leading-relaxed max-w-md mx-auto mb-10">
            your piece is reserved. the atelier will contact you shortly with delivery details.
            beautiful things deserve another story — and yours has just begun.
          </p>

          {session && (
            <div className="bg-linen border border-taupe/50 p-6 text-left mb-10" data-testid="session-card">
              <p className="editorial-label">{session.item_title?.toLowerCase()}</p>
              <p className="font-serif text-3xl text-charcoal mt-2">{formatMoney(session.amount)}</p>
              <p className="text-[0.65rem] text-taupe tracking-widest uppercase mt-3">session · {session.id}</p>
              <p className="text-[0.65rem] text-taupe tracking-widest uppercase mt-1">status · {session.status} {session.mock ? "· mock" : ""}</p>
            </div>
          )}

          <Link to="/shop" data-testid="back-to-shop" className="inline-block bg-brass hover:bg-espresso text-ivory px-10 py-4 text-sm tracking-[0.25em] uppercase transition-colors">
            continue browsing
          </Link>
          <p className="editorial-label mt-8">curated with intention.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
